import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'tui-calendar/dist/tui-calendar.css';
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';
import 'tippy.js/dist/tippy.css';
import '@yaireo/tagify/dist/tagify.css';
import * as R from 'ramda';
import { defaultColor } from './constants/defaultValues';

window.R = R;

const render = () => {
  import('./assets/css/sass/themes/gogo.' + defaultColor + '.scss').then((x) => {
    require('./AppRenderer');
  });
};
render();
